import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ObtenerInformacionAdicionalPrestamoME, ObtenerInformacionAdicionalPrestamoMS, PrestamoService } from 'src/app/open-api';
import { DevuelveComponentesAPagarPrestamoME } from 'src/app/open-api/model/devuelveComponentesAPagarPrestamoME';
import { DevuelveComponentesAPagarPrestamoMS } from 'src/app/open-api/model/devuelveComponentesAPagarPrestamoMS';
import { EMPTY_STRING } from 'src/app/shared/utils/regular-expresions';

@Component({
  selector: 'app-prestamo-informacion',
  templateUrl: './prestamo-informacion.component.html',
  styleUrls: ['./prestamo-informacion.component.scss']
})
export class PrestamoInformacionComponent implements OnInit {

  @Input() set SecuencialPrestamo(secuencial: number) {
    this.secuencialPrestamo = secuencial;
    this.ObtenerInformacionAdicional();
  }
  secuencialPrestamo = 0;
  informacion?: ObtenerInformacionAdicionalPrestamoMS;
  informacionAdiciona?:DevuelveComponentesAPagarPrestamoMS;
  totalCuotas:string=EMPTY_STRING
  cuotaActual:string=EMPTY_STRING

  constructor(
    private prestamoService: PrestamoService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }



  ObtenerInformacionAdicional() {
    this.spinner.show();
    const parametro: ObtenerInformacionAdicionalPrestamoME = {
      secuencialPrestamo: this.secuencialPrestamo
    };
    this.prestamoService.apiV10PrestamoObtenerInformacionAdicionalPost(parametro).subscribe(informacion => {
      this.informacion = informacion;
      this.ObtenerInformacionAdicionalPrestamo();
      this.spinner.hide();
    });
  }


  ObtenerInformacionAdicionalPrestamo(){
    const parametro:DevuelveComponentesAPagarPrestamoME={
      secuencialPrestamo:this.secuencialPrestamo
    }
    this.prestamoService.apiV10PrestamoDevuelveComponentesAPagarPorSecuencialPrestamoPost(parametro).subscribe(prestamo=>{
      this.informacionAdiciona = prestamo
      this.totalCuotas = prestamo.totalCuotas?.toString() ?? '0'

this.cuotaActual = prestamo.componentesCarteraResumen && prestamo.componentesCarteraResumen[0] && prestamo.componentesCarteraResumen[0].numeroCuota !== undefined
? (Number(prestamo.componentesCarteraResumen[0].numeroCuota) - 1).toString()
: '0';

    })
  }
  
}
